// src/admin/AddEventForm.js

import React, { useState } from 'react';
import { db, storage } from '../config/firebaseConfig';
import { collection, addDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const AddEventForm = () => {
  const [name, setName] = useState('');
  const [location, setLocation] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [eventLink, setEventLink] = useState(''); // Etkinlik linki için state
  const [poster, setPoster] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setPoster(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    if (!poster) {
      setMessage('Please select a poster image.');
      setLoading(false);
      return;
    }

    try {
      // 1. Resmi Firebase Storage'a yükle
      const storageRef = ref(storage, `event-posters/${poster.name}`);
      await uploadBytes(storageRef, poster);
      const posterUrl = await getDownloadURL(storageRef);

      // 2. Etkinlik verilerini (eventLink dahil) Firestore'a kaydet
      await addDoc(collection(db, 'events'), {
        name,
        location,
        date,
        time,
        eventLink, // Yeni eklenen alan
        posterUrl,
        createdAt: new Date(),
      });

      setMessage('Event successfully added!');
      
      // Formu temizle
      setName('');
      setLocation('');
      setDate('');
      setTime('');
      setEventLink(''); // Link alanını temizle
      setPoster(null);

    } catch (error) {
      console.error("Error adding event: ", error);
      setMessage('An error occurred while adding the event.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <h2>Add New Event</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Event Name</label>
          <input 
            type="text" 
            className="form-control" 
            value={name}
            onChange={(e) => setName(e.target.value)}
            required 
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Location</label>
          <input 
            type="text" 
            className="form-control" 
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            required 
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Date</label>
          <input 
            type="text" 
            className="form-control" 
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required 
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Time</label>
          <input 
            type="text" 
            className="form-control" 
            value={time}
            onChange={(e) => setTime(e.target.value)}
            required 
          />
        </div>
        
        {/* Yeni Eklenen Event Link Alanı */}
        <div className="mb-3">
          <label className="form-label">Event Link</label>
          <input 
            type="url" 
            className="form-control" 
            value={eventLink}
            onChange={(e) => setEventLink(e.target.value)}
            placeholder="https://example.com/event-details"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Poster Image</label>
          <input 
            type="file" 
            className="form-control" 
            onChange={handleFileChange}
            required 
          />
        </div>
        <button type="submit" className="btn btn-success" disabled={loading}>
          {loading ? 'Adding...' : 'Add Event'}
        </button>
      </form>
      {message && <div className="mt-3 alert alert-info">{message}</div>}
    </div>
  );
};

export default AddEventForm;